import React from "react";
import styled from "styled-components";
import { FaPlus, FaMinus } from "react-icons/fa";

const AmountButtons = ({ increase, decrease, amount }) => {
  return (
    <Wrapper className="amount-btns">
      <button
        type="button"
        className="amount-btn"
        onClick={decrease}
        aria-label="Snížit množství"
      >
        <FaMinus />
      </button>
      <span className="amount" aria-live="polite">
        {amount}
      </span>
      <button
        type="button"
        className="amount-btn"
        onClick={increase}
        aria-label="Zvýšit množství"
      >
        <FaPlus />
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--clr-cream);
  border: 1px solid var(--clr-divider);
  border-radius: var(--radius-pill);
  padding: 0.25rem;

  .amount-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    min-width: 40px;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--clr-charcoal-1);
    transition: var(--transition);
  }
  .amount-btn:hover {
    background: var(--clr-accent);
    color: var(--clr-paper);
  }
  .amount-btn:active {
    transform: scale(0.95);
  }
  .amount-btn svg {
    font-size: 0.85rem;
  }

  .amount {
    min-width: 2rem;
    text-align: center;
    font-family: var(--ff-display);
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--clr-charcoal-1);
    margin: 0;
  }
`;

export default AmountButtons;
